import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RevendedoresService } from '../services/revendedores.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertComponent } from "../../../alert/alert.component";
import { LoadingModalComponent } from "../../../loading-modal/loading-modal.component";

@Component({
  selector: 'app-revendedores',
  standalone: true,
  imports: [CommonModule, MatIconModule, ReactiveFormsModule, FormsModule, AlertComponent, LoadingModalComponent],
  templateUrl: './revendedores.component.html',
  styleUrls: ['./revendedores.component.scss'],
  providers: [RevendedoresService]
})
export class RevendedoresComponent  implements OnInit {
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  //Variaveis de listagem
  public listRevendedores: Array<any> = [];
  public totalRevendedores = 0;
  public totalSplitAtivos = 0;
  
  //variaveis do modal de cadastrar o revendedor
  public isModalCreateNewRevendedor: boolean = false;
  public formRegisterRevendedor!: FormGroup;
  
  public predefinedObject: any = {
    title: "Title",
    theme: {
      colors: {
        primaryColor: "#00d08b",
        primaryColorHover: "#00b97a",
        darkColor: "#333333",
        lightColor: "#ffffff",
        borderColor: "#cccccc",
        boxShadowColor: "rgba(0, 208, 139, 0.5)"
      },
      font: {
        fontFamily: "Inter, sans-serif"
      },
      sizes: {
        fontSizeBase: "16px",
        fontSizeLarge: "24px",
        fontSizeSmall: "14px"
      },
      spacing: {
        paddingBase: "10px",
        borderRadius: "4px"
      },
      zIndexes: {
        index1: 999,
        index2: 1010,
        index3: 1100
      },
      image: {
        widthImage: '200px',
        heightImage: '100px'
      }
    }
  }


  constructor(private revendedorService: RevendedoresService, private fb: FormBuilder) { }

  ngOnInit() {
    this.getListRevendedores();
  }
  
  public getListRevendedores(){
    this.revendedorService.getRevendedores().subscribe((response: any)=>{
      this.listRevendedores = response || [];
      this.totalRevendedores = this.listRevendedores.length;
      this.totalSplitAtivos = this.listRevendedores.filter((item) => item?.split).length;
    })
  }

  public openModalCreateNewRevendedor(){
    this.formRegisterRevendedor = this.fb.group({
      username: [''],
      password: [''],
      revendedor: [''],
      nome: [''],
      type: ['individual'],
      email: [''],
      documenttype: ['CPF'],
      document: [''],
      telefone: [''],
      price: [1],
      split: [true],
      hostSite: [''],
      stylesHost: [JSON.stringify(this.predefinedObject, null, 2)]
    })
    this.isModalCreateNewRevendedor = true;
  }

  public closeModalCreateNewRevendedor(){
    this.isModalCreateNewRevendedor = false;
  }

  public cadastrarRevendedor() {
    
    this.loadingComponent.activeLoading();
    this.revendedorService.setRevendedor(this.formRegisterRevendedor.value).subscribe((response: any)=>{
      this.getListRevendedores();
      this.alertComponent.showAlert('Revendedor cadastrado com sucesso!');
      this.loadingComponent.inactiveLoading();
      this.closeModalCreateNewRevendedor();
    },(error: any)=> {
      console.log(error.error);
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao cadastrar revendedor: ${error.error.status}`)
    })
  }

  public formatarTelefone(){
    const telefoneFormatado = this.formRegisterRevendedor.value.telefone.replace(/\+55|\D/g, '');
    console.log(telefoneFormatado);
    
    if(telefoneFormatado.length === 10){
      this.formRegisterRevendedor.get('telefone')?.setValue(telefoneFormatado.replace(/^(\d{2})(\d{4})(\d{4})$/, '+55 $1 $2 $3'))
    }else
    if(telefoneFormatado.length >= 11){
      this.formRegisterRevendedor.get('telefone')?.setValue(telefoneFormatado.replace(/^(\d{2})(\d{5})(\d{4})$/, '+55 $1 $2 $3'))
    }

    
  }

  public formatarDocument(): void{
    const documentoFormatado = this.formRegisterRevendedor.value.document.replace(/\D/g, '');

    if(documentoFormatado.length <= 11){
      this.formRegisterRevendedor.get('document')?.setValue(documentoFormatado.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/,'$1.$2.$3-$4'))
    }

    if(documentoFormatado.length >11){
      this.formRegisterRevendedor.get('document')?.setValue(documentoFormatado.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5'))
    }
  }
}
